import React, { useState } from 'react';
import { Box, Collapse } from '@mui/material';
import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BillingForm } from './forms/BillingForm';
import { SectionHeader } from './SectionHeader';

export const BillingSection = ({
  paymentMethod,
  setPaymentMethod,
  yNumber,
  setYNumber,
  companyName,
  setCompanyName,
  paymentReference,
  setPaymentReference,
  billingDepartment,
  setBillingDepartment,
  inModal = false,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const methodLabel = paymentMethod === 'invoice'
    ? (t('delivery.invoice') || 'Invoice')
    : (t('delivery.card') || 'Card');
  const summary = [methodLabel, companyName, yNumber].filter(Boolean).join(' · ');

  return (
    <Box>
      <SectionHeader
        icon={<CreditCard size={16} />}
        title={t('delivery.billingInfo') || 'Billing Information'}
        subtitle={summary}
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        inModal={inModal}
      />

      <Collapse in={expanded}>
        <Box sx={{ pl: inModal ? 3.5 : 4.5, pt: 1.5, pb: 1 }}>
          <BillingForm
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            yNumber={yNumber}
            setYNumber={setYNumber}
            companyName={companyName}
            setCompanyName={setCompanyName}
            paymentReference={paymentReference}
            setPaymentReference={setPaymentReference}
            billingDepartment={billingDepartment}
            setBillingDepartment={setBillingDepartment}
          />
        </Box>
      </Collapse>
    </Box>
  );
};